import { defineComponent as _defineComponent } from 'vue'
import { useStore } from "@/store";
import { ActionTypes } from "@/store/action-types";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose }) {
  expose();

const documentInput = ref(null);
const store = useStore();

const document = computed(() => store.state.document);
const isLoadingDocument = computed(() => store.state.isLoadingDocument);

function accept() {
  store.dispatch(ActionTypes.ACCEPTDOCUMENT);
}

function scanDocument() {
  (documentInput.value! as HTMLInputElement).click();
}

async function onDocumentScanned(event: Event) {
  const file = (event.target as HTMLInputElement).files![0];
  store.dispatch(ActionTypes.PROCESSDOCUMENT, file);
}

const __returned__ = { documentInput, store, document, isLoadingDocument, accept, scanDocument, onDocumentScanned, get useStore() { return useStore }, get ActionTypes() { return ActionTypes }, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})